export const publishableKey =
  "pk_live_51LmvazI4GOyvleTSrNPk2KzWGFZP0bzjxtGhsk6EaXrnnmS46KxcaM441SVPISxuMluJkNrDIH4kkOqiFiGNo49V00m992udC6";
